// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.backgroundImg404{
    background: white;
    padding-bottom: 400px;
}

.backgroundImg404 .page404{
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.backgroundImg404 .page404 h1{
    color: #113254;
    font-size: 50px;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Page404/styles.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB","sourcesContent":[".backgroundImg404{\n    background: white;\n    padding-bottom: 400px;\n}\n\n.backgroundImg404 .page404{\n    height: 500px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.backgroundImg404 .page404 h1{\n    color: #113254;\n    font-size: 50px;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
